import { MEMBER_URL } from 'volto-m4-theme-addon/constants/MemberActionTypes';

/**
 * Get request key
 * @function getRequestKey
 * @param {string} actionType Action type.
 * @returns {string} Request key.
 */
function getRequestKey(actionType) {
  return actionType.split('_')[0].toLowerCase();
}

const initialState = {
  member: {
    member_url: null,
    loaded: false,
    loading: false,
    error: null,
  },
};

export default function memberUrl(state = initialState, action = {}) {
  switch (action.type) {
    case `${MEMBER_URL}_PENDING`:
      return {
        ...state,
        [getRequestKey(action.type)]: {
          member_url: null,
          loading: true,
          loaded: false,
          error: null,
        },
      };
    case `${MEMBER_URL}_SUCCESS`:
      return {
        ...state,
        [getRequestKey(action.type)]: {
          member_url: action.result,
          loading: false,
          loaded: true,
          error: null,
        },
      };
    case `${MEMBER_URL}_FAIL`:
      return {
        ...state,
        [getRequestKey(action.type)]: {
          member_url: null,
          loading: false,
          loaded: false,
          error: action.error,
        },
      };
    default:
      return state;
  }
}
